import { WebglSettingsConverter } from "../../webgl-settings-converter";
import { VisualizatorSettings } from "../../../settings/visualizator-settings";
import { getItemByField, ObjectCreator } from "../../../../../../../web-graphics";

export class ChannelConfigurationWebglSettingsConverter extends WebglSettingsConverter {
  constructor(commonSettings, signalConverter) {
    super();
    this.commonSettings = commonSettings;
    this.signalConverter = signalConverter;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    delete settingsCopy.name_configuration;
    settingsCopy.name = settings.name_configuration;
    if (settings._isNeedChannelLeadRay) {
      if (settingsCopy.plotContent === undefined) {
        settingsCopy.plotContent = {};
      }
      if (settingsCopy.plotContent.aboveCentral == undefined) {
        settingsCopy.plotContent.aboveCentral = [];
      }
      let leadRaySettings = getItemByField("name", "leadRay", settingsCopy.plotContent.aboveCentral);
      if (leadRaySettings === undefined) {
        let commonLeadRaySettings = getItemByField("name", "leadRay", settings._plotSettings.plotContent?.aboveCentral);
        let leadRaySettingsCopy = commonLeadRaySettings.copy();
        leadRaySettingsCopy.settings.id_dataSource = settings.id_dataSource;
        leadRaySettingsCopy.settings.id_channel = settings.id_channel;
        settingsCopy.plotContent.aboveCentral.push(leadRaySettingsCopy);
      }
    }
    let commonConfigSettings = settings._commonSettings;
    if (commonConfigSettings !== undefined) {
      for (const key of Object.getOwnPropertyNames(commonConfigSettings)) {
        if (key == "signals") {
          if (settings.signals !== undefined) {
            settingsCopy.signals = [];
            for (let signalIndex = 0; signalIndex < settings.signals.length; signalIndex++) {
              let signalSettings = settings.signals[signalIndex].copy();
              signalSettings.id_dataSource = settings.id_dataSource;
              signalSettings.id_channel = settings.id_channel;
              signalSettings.name_configuration = settings.name_configuration;
              signalSettings._commonSettings = getItemByField("id", settings.signals[signalIndex].id_signal, commonConfigSettings.signals);
              let convertedSignalSettings = this.signalConverter.convert(signalSettings);
              if (convertedSignalSettings !== undefined) {
                settingsCopy.signals.push(convertedSignalSettings);
              }
            }
          }
        } else if (settingsCopy[key] === undefined) {
          if (commonConfigSettings[key] instanceof VisualizatorSettings) {
            settingsCopy[key] = commonConfigSettings[key].copy();
          } else {
            settingsCopy[key] = ObjectCreator.deepCopy(commonConfigSettings[key]);
          }
        }
      }
    }
    return settingsCopy;
  }
}
